module.exports = __webpack_public_path__ + "img/license-CC BY.37afe62b.png";